module.exports = __webpack_public_path__ + "public/HelpPage/block2img.jpeg?00558672";